import React from 'react'
import Card from 'components/card'
import { string, bool, oneOfType, node, arrayOf } from 'prop-types'
import styled from 'styled-components'
import { fonts } from 'assets/fontStyles'
import colours from 'assets/colours'
import queries, { minQuery, devices } from 'utils/responsivenessHelper'

const Subtitle = styled.div`
  ${fonts.p}
  padding-top: 0.3125em;
`

const Title = styled.div`
  ${fonts.heading6};
  font-weight: 500;

  span {
    font-weight: inherit;
    font-size: 1rem;
    color: ${colours.grey2};
  }
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 36px;
  padding: 0px 15px;
`

const LayoutCard = styled(Card)`
  padding: 40px 30px;
  margin: 15px;
  flex: 1;

  ${queries.both({
    padding: '40px 20px',
  })}

  ${minQuery.both(
    {
      minWidth: '500px',
    },
    null,
    devices.iPad
  )};
`

export const Header = ({ title, subtitle, required }) => (
  <HeaderWrapper>
    <Title>
      {title} {required && <span>(required)</span>}
    </Title>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </HeaderWrapper>
)

const Layout = ({ title, subtitle, required, children, ...rest }) => {
  return (
    <LayoutCard {...rest}>
      <HeaderWrapper>
        <Title>
          {title} {required && <span>(required)</span>}
        </Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeaderWrapper>
      {children}
    </LayoutCard>
  )
}

export default Layout

Layout.defaultProps = {
  required: false,
  subtitle: '',
}

Layout.propTypes = {
  title: string.isRequired,
  subtitle: string,
  required: bool,
  children: oneOfType([arrayOf(node), node]).isRequired,
}
